import React from 'react';

import * as formatters from '../../../utils/formatters';
import ViewButton from '../../elements/ViewButton';

import { PERMISSION } from 'crm/helpers/Permissions';

function VouchersTableDefault({ vouchers }) {
    function getUserLink(userId) {
        if (userId) {
            return <ViewButton url={`/users/${userId}`} permissions={[PERMISSION.VIEW_USER]} key="view" />;
        }
        return null;
    }

    function getVouchers() {
        const { formatDateStringWithTimezone } = formatters;
        return vouchers.map(
            ({ id, code, amount_value, amount_currency, reseller_id, consumer_id, consumed_at, created_at }) => (
                <tr key={id}>
                    <td>{id}</td>
                    <td>{code}</td>
                    <td>{amount_value}</td>
                    <td>{amount_currency}</td>
                    <td>{getUserLink(reseller_id)}</td>
                    <td>{getUserLink(consumer_id)}</td>
                    <td>{formatDateStringWithTimezone(consumed_at)}</td>
                    <td>{formatDateStringWithTimezone(created_at)}</td>
                </tr>
            )
        );
    }

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Reseller</th>
                    <th>Consumer</th>
                    <th>Consumed at</th>
                    <th>Created at</th>
                </tr>
            </thead>
            <tbody>{getVouchers()}</tbody>
        </table>
    );
}

export default VouchersTableDefault;
